import { render } from "./OrderPage.vue?vue&type=template&id=d962feec&scoped=true"
import script from "./OrderPage.vue?vue&type=script&lang=js"
export * from "./OrderPage.vue?vue&type=script&lang=js"

import "./OrderPage.vue?vue&type=style&index=0&id=d962feec&lang=scss&scoped=true"
import "./OrderPage.vue?vue&type=style&index=1&id=d962feec&lang=css"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d962feec"]])

export default __exports__